var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.name},[_c('b-field',{attrs:{"label":_vm.label}},[_c('b-input',{attrs:{"value":_vm.currentValue,"disabled":_vm.disabled,"placeholder":"Valor"},on:{"input":_vm.set}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }